$(() => {
  const open = $(".aws-service-modal.modal-open");
  const close = $(".aws-service-modal.modal-close");
  const container = $(".aws-service-modal.modal-container");
  const body = $(".aws-service-modal.modal-body");
  let trigger = null;

  const FOCUSABLE =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  function openModal() {
    trigger = document.activeElement;
    document.body.style.overflow = "hidden";
    container.addClass("active").attr("aria-hidden", "false");
    close.trigger("focus");
  }

  function closeModal() {
    container.removeClass("active").attr("aria-hidden", "true");
    document.body.style.overflow = "";
    if (trigger) {
      $(trigger).trigger("focus");
      trigger = null;
    }
  }

  function trapFocus(e) {
    const focusable = body.find(FOCUSABLE).filter(":visible");
    if (!focusable.length) return;
    const first = focusable.first()[0];
    const last = focusable.last()[0];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  open.on("click", function () {
    openModal();
    return false;
  });

  close.on("click", function () {
    closeModal();
  });

  $(document).on("keydown", function (e) {
    if (!container.hasClass("active")) return;
    if (e.key === "Escape") {
      closeModal();
    } else if (e.key === "Tab") {
      trapFocus(e);
    }
  });

  $(document).on("click", function (e) {
    if (
      container.hasClass("active") &&
      !$(e.target).closest(".aws-service-modal.modal-body").length
    ) {
      closeModal();
    }
  });
});
